import React, { Component } from "react";

import "./sass/normalise.css";
import "./sass/font-families.css";
import "swiper/dist/css/swiper.css";    // Swiper CSS
import "flatpickr/dist/flatpickr.css";  // Flatpickr CSS
import "./App.css";

import G from "./js/globals";
import E from "./js/events";
import A from "axios";   // Axios  - https://github.com/axios/axios
// import M from "moment";  // Moment - https://momentjs.com/

import Loader         from "./components/prefabs/loader/view";
import PopupBox       from "./components/widgets/popup-box/view";
import ScreenCarousel from "./components/screens/carousel/view";

import restaurantslocal from "./restaurants.json";

// Native smooth-scrolling polyfill
window.__forceSmoothScrollPolyfill__ = true;
require("smoothscroll-polyfill").polyfill();

class App extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.setupState        = this.setupState.bind(this);
    this.getProductData    = this.getProductData.bind(this);
    this.getLocationData   = this.getLocationData.bind(this);

    this.handleAppEvent    = this.handleAppEvent.bind(this);
    this.handleAppPopup    = this.handleAppPopup.bind(this);

    this.state = {

      eventType:     'hosted',  // Hosted or no host
      // App info
      // app_info_standard: null,  // "Classic Party Package" info
      // app_info_premium:  null,  // "Premium Party Package" info
      // app_info_noHost:   null,  // "No Host Package" info
      // app_info_byoCake:  null,  // "Free Cake" info

      // App cache
      app_cache_locations: null,  // List of locations
      app_cache_products: null,  // List of products



      // App state
      app_visitedSlides: [],
      app_activeSlide:   null,
      app_activeSlideId: null,
      // Create an array of slide info
      // Note 1: this array sets the order of slides
      // Note 2: title is used in the header
      items: [
        { id: "eventType",    title: "Event Type"   },
        { id: "intro",        title: "Intro"        },
        { id: "location",     title: "Where"        },
        { id: "package",      title: "Who"          },
        { id: "datetime",     title: "When"         },
        { id: "cake",         title: "Inclusions"   },
        { id: "summary",      title: "Summary"      },
      ],

      app_totalPrice:    0,
      app_loginState:    null,
      app_editState:     null,
      app_popupConfig:   { open: false },
      app_cake: null,

      // IntroSection state
      intro_counter:  0,
      intro_starList: [],

      // PackageSection state
      package_numChilds: 0,
      package_numAdults: 1,
      // package_isPremium: false,

      // LocationSection state
      location_query:       "",
      location_selLocation: null,

      // DatetimeSection state
      datetime_selDate: null,
      datetime_selTime: null,

      // CakeSection state
      cake_numCakes: 0,
      cake_isByo:    false,
      cake_numOptionalInclusionsNoHost: {},

      // SummarySection state
      summary_firstName: "",
      summary_lastName: "",
      summary_email: "",

      summary_phone: "",
      summary_reqs:  "",

      summary_tAndC:  "",
      summary_privacy:  "",
    }



    this.loaded = false;
    this.loadsNeeded = 2;
    this.loadCounter = 0;  // Used to determine if all our API calls have been made

    this.cacheProducts   = null;
    this.cacheLocations  = null;
    this.cacheLoginResponse = null;
    this.cacheEditResponse  = null;

    this.bookmarkProducts  = "MCD_PARTY_BOOKING_PRODUCTS";
    this.bookmarkLocations = "MCD_PARTY_BOOKING_LOCATIONS";




    // Add index keys (keys are used in React loops as well as slides)
    this.state.items.forEach((item, i) => { item.key = i; });
  }



  // ===============================================================================================
  // Handles popup management
  handleAppPopup(popup) {
    if (popup.isPopupConfig) { this.setState({ app_popupConfig: popup.toObject() }); }
  }



  // ===============================================================================================
  // Handles events bubbling up from components
  handleAppEvent(name, event) {
    this.setState( E.handleEvent(this.state, name, event) );
  }



  // ===============================================================================================
  // Handle slide change
  handleSlideChange(newActiveSlideIndex) {
    this.handleAppEvent(E.events.APP_SLIDE_CHANGED, newActiveSlideIndex);
  }



  // ===============================================================================================
  // On startup
  componentDidMount() {
    // Get all of our data from the servers
    this.getProductData();
    this.getLocationData();
    this.getToken()
  }

  async getToken() {
    const response = await A.get(G.data.getGenerate(), G.data.getLogin())
    this.setState({ app_cake: response.data.token })
  }

  // ===============================================================================================
  // Gets product data from the server (or session storage)
  getProductData() {
    if (window.sessionStorage[this.bookmarkProducts]) {
      let oldProductsList = window.sessionStorage[this.bookmarkProducts];
      oldProductsList = (oldProductsList) ? JSON.parse(oldProductsList) : null;

      // Verify this is actually a product list...
      if (oldProductsList &&
          // oldProductsList.hasOwnProperty("app_info_standard") &&
          // oldProductsList.hasOwnProperty("app_info_premium" ) &&
          // oldProductsList.hasOwnProperty("app_info_noHost") &&
          // oldProductsList.hasOwnProperty("app_info_cake"    ) &&
          // oldProductsList.hasOwnProperty("app_info_byoCake" ) &&
          oldProductsList.hasOwnProperty("app_cache_products")
        ) {

        // console.log("APP:\n loading products from cache", oldProductsList);
        this.cacheProducts = oldProductsList;
        this.checkIfReady();
        // return;
      }
    }

    // If we don't have a saved copy of the products list, we need to request it
    A.get(G.data.getProducts(), G.data.getLogin())
      .then((response) => {
        // console.log("APP:\n api/products", response);

        let list = {};
        response.data.forEach((product) => {
          // let price = ("" + product["product_price"]).replace(".", "");
          let price = "" + product["product_price"];

          if (price.indexOf(".") === -1) {
            price = parseInt(price, 10) * 100;
          }
          else {
            let priceArr = price.split(".");
            if (priceArr[1].length < 2) { priceArr[1] = priceArr[1] + "0"; }
            price = parseInt(priceArr[0] + priceArr[1], 10);
          }

          list[ product["product_name"] ] = {
            name:  product["product_title"],
            price: price,
            allow_store_level_pricing: product["allow_store_level_pricing"],
            optional_inclusion_no_host: product["optional_inclusion_no_host"],
            view:  JSON.parse(product["product_details"]),
          };
        });

        let newProductsList = {
          // app_info_standard: list["happy_party_package"],
          // app_info_premium:  list["premium_party_package"],
          app_cache_products: list,
          // app_info_noHost:   list["no_host_package"],
          // app_info_byoCake:  list["free_cake"],
        };

        window.sessionStorage[this.bookmarkProducts] = JSON.stringify(newProductsList);
        this.cacheProducts = newProductsList;
        this.checkIfReady();
      })



    // Error if we couldn't get products
    .catch(error => {
      // console.log("APP:\n api/products", error)

      // If we're not on localhost we need to popup a warning
      if (!G.isLocalhost && !G.isStaging) {
        let newErrorPopup = G.popups.newPopup().lock(true)
          .code(G.errors.ERR_GET_PRODUCTS_FAILED)
          .heading("Something went wrong.")
          .message((
            <div>
              <p> We couldn't load all our details. </p>
              <p> Please try again later. </p>
            </div>
          ))
          .confirm("Retry", () => {
            // console.log("RELOADING PAGE");
            window.location.reload();
          });

        this.handleAppPopup(newErrorPopup);
        // this.checkIfReady();
      }



      // Otherwise if we're on localhost we can create fake product data, for testing purposes
      else {
        console.warn("APP:\n api/products - STUBBING PRODUCT DATA");

        let newFakeProductList = {
          // app_info_standard: { name: "The Classic Party Package", price:  995, view: {} },
          // app_info_premium:  { name: "Premium Party Package",   price: 1295, view: {} }
          app_cache_products: [],
          // app_info_noHost:   { name: "No Host Package",         price:  599, view: {} },
          // app_info_byoCake:  { name: "Free Cack",               price:    0, view: {} },
        };

        this.cacheProducts = newFakeProductList;
        this.checkIfReady();
      }

    });
  }



  // ===============================================================================================
  // Gets location data from the server (or session storage)
  getLocationData() {
    if (window.sessionStorage[this.bookmarkLocations]) {
      let oldLocationsList = window.sessionStorage[this.bookmarkLocations];
      oldLocationsList = (oldLocationsList) ? JSON.parse(oldLocationsList) : null;

      // Verify this is actually a locations list...
      if (oldLocationsList && oldLocationsList.hasOwnProperty("app_cache_locations")) {
        // console.log("APP:\n loading locations from cache", oldLocationsList);
        this.cacheLocations = oldLocationsList;
        this.checkIfReady();
        return;
      }
    }

    // If we don't have a saved copy of the locations list, we need to request it
    A.get(G.data.getRestaurants(), G.data.getLogin())
      .then(response => {
        // console.log("APP:\n api/restaurants", response);

        for (let i = 0; i < response.data.length; i++) {
          let item = response.data[i];

          if (item["store_level_pricing"] != null && item["store_level_pricing"] !== '') {
            // console.log("APP:\n api/restaurants", item["store_level_pricing"]);
                for (const [key, product] of Object.entries(item["store_level_pricing"])) {
                  item["store_level_pricing"][key].price = this.formatPrice(product.product_price);
                  // console.log("APP:\n api/restaurants", item["store_level_pricing"][key]);
                }
          }

          // item.name    = item["store_suburb"];
          item.name    = item["title"];
          item.address = item["store_address"] + ", " + item["store_suburb"] + " " + item["store_state"];
          item.postcode = item["store_postcode"];
          item.latitude = item["lat_long.lat"];
          item.longitude = item["lat_long.lng"];
        }

        let newLocationsList = {
          app_cache_locations: response.data
        };

        window.sessionStorage[this.bookmarkLocations] = JSON.stringify(newLocationsList);
        this.cacheLocations = newLocationsList;
        this.checkIfReady();
      })



    // Error if we couldn't get the restaurants
    .catch(error => {
      // console.log("APP:\n api/restaurants", error)

      // If we're not on localhost we need to popup a warning
      if (!G.isLocalhost && !G.isStaging) {
        let newErrorPopup = G.popups.newPopup().lock(true)
          .code(G.errors.ERR_GET_RESTAURANTS_FAILED)
          .heading("Something went wrong.")
          .message((
            <div>
              <p> We couldn't load all our details. </p>
              <p> Please try again later. </p>
            </div>
          ))
          .confirm("Retry", () => {
            // console.log("RELOADING PAGE");
            window.location.reload();
          });

        this.handleAppPopup(newErrorPopup);
        // this.checkIfReady();
      }
      // Otherwise if we're on localhost we can create fake location data, for testing purposes
      else {
        console.warn("APP:\n api/restaurants - STUBBING LOCATION DATA");

        let newFakeLocationsList = {
          app_cache_locations: restaurantslocal
        }

        for (let i = 0; i < newFakeLocationsList.app_cache_locations.length; i++) {
          let item = newFakeLocationsList.app_cache_locations[i];
          // item.name    = item["store_suburb"];
          // item.address = item["store_address"] + " " + item["store_postcode"] + " " + item["store_state"];
          item.name    = item["title"];
          item.address = item["store_address"] + " " + item["store_postcode"] + " " + item["store_suburb"] + " " + item["store_state"];
          item.postcode = item["store_postcode"];
          item.latitude = item["lat_long.lat"];
          item.longitude = item["lat_long.lng"];
        }

        this.cacheLocations = newFakeLocationsList;
        this.checkIfReady();
      }
    });
  }



  // ===============================================================================================
  formatPrice(priceInput) {
    let price = "" + priceInput;

    if (price.indexOf(".") === -1) {
      price = parseInt(price, 10) * 100;
    }
    else {
      let priceArr = price.split(".");
      if (priceArr[1].length < 2) { priceArr[1] = priceArr[1] + "0"; }
      price = parseInt(priceArr[0] + priceArr[1], 10);
    }
    return price;
    // Short version below has some rounding issues, thus keeping the above longer version
    // return parseInt(parseFloat(priceInput) * 100, 10);
  }



  // ===============================================================================================
  // Check if the app is ready to start
  checkIfReady() {
    this.loadCounter++;  // UGH

    // Check if we've loaded enough stuff
    if (this.loadCounter >= this.loadsNeeded) {
      this.setupState();
    }
  }



  // ===============================================================================================
  // Setup app state
  setupState() {
    // console.log("APP:\n LOADING STATE!");

    // Create a state change from out API cache
    let changedState = {};

    if (this.cacheProducts) {
      for (let key in this.cacheProducts) {
        if (this.cacheProducts.hasOwnProperty(key)) {
          changedState[key] = this.cacheProducts[key];
        }
      }
    }

    if (this.cacheLocations) {
      for (let key in this.cacheLocations) {
        if (this.cacheLocations.hasOwnProperty(key)) {
          changedState[key] = this.cacheLocations[key];
        }
      }
    }



    // If we're in edit mode, we need to load the editState instead
    if (this.cacheEditResponse) {
      changedState._loginResponse = this.cacheLoginResponse;
      changedState._editResponse  = this.cacheEditResponse;

      changedState.app_activeSlide   = 1;  // Skip children screen
      changedState.app_visitedSlides = [];

      this.state.items.forEach((item) => {
        changedState.app_visitedSlides.push(item.key);
      });
    }



    // Attempt to load state from memory
    let newState = E.handleEvent(this.state, E.events.APP_LOADED, changedState);

    // If a loadable state is found, sort out slide-visited
    if (newState) {
      let activeSlide = null;

      if (typeof newState["app_activeSlide"] === "number") {
        // Sanitize active slider, if it exists
        activeSlide = newState["app_activeSlide"];
        if (activeSlide < 0) { activeSlide = 0; }
        if (activeSlide > this.state.items.length) { activeSlide = this.state.items.length; }
      }

      newState["app_activeSlide"] = activeSlide;

      // Finally, trigger app startup!
      // console.log("LOADUP STATE:\n ", newState);
      this.loaded = true;
      this.setState(newState);
    }



    // If no state is returned, something screwed up big time!
    else {
      let newErrorPopup = G.popups.newPopup().lock(true)
        .code(G.errors.ERR_INVALID_STATE_LOADED)
        .heading("Something went wrong.")
        .message((
          <div>
            <p> We couldn't load your booking info. </p>
            <p> Please try again later. </p>
          </div>
        ))
        .confirm("Retry", () => {
          // console.log("RELOADING PAGE");
          window.location.reload();
        });

      this.handleAppPopup(newErrorPopup);
    }
  }



  // ===============================================================================================
  render() {
    // ---------------------------------------------------------------------------------------------
    // Get current slide name (controls background colour in CSS)
    let slideName = null;
    if (this.state.items && this.state.items[this.state.app_activeSlide]) {
      slideName = this.state.items[this.state.app_activeSlide].id;
    }



    // ---------------------------------------------------------------------------------------------
    let contents = (
      <div className="app-loader-container">
        <Loader className="app-loader" text={true}/>
      </div>
    );



    // ---------------------------------------------------------------------------------------------
    if (this.loaded === true) {
      contents = (
        <ScreenCarousel
          {...this.state}
          items={this.state.items}
          handleAppEvent={this.handleAppEvent}
          handleAppPopup={this.handleAppPopup}
          handleSlideChange={this.handleSlideChange}
        />
      );
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <div className={"Mcd_BPB" +
        ((slideName) ? " Mcd_BPB--" + slideName : "") + 
        ((this.state.eventType) ? " Mcd_BPB--eventType--" + this.state.eventType : "")}>
        

        <PopupBox config={this.state.app_popupConfig}/>

        {contents}

        <div className="Mcd_BPB__disclaimer-box">
          <div className={"Mcd_BPB__disclaimer-box__wrapper" +
            ((this.state.app_activeSlide < 1) ? " Mcd_BPB__disclaimer-box__wrapper--hidden" : "")}>
            <p className="privacy-collection-text">McDonald’s Australia and its franchisees are committed to protecting your personal information in accordance with the Australian Privacy Principles contained in the Privacy Act 1988. When you book a McDonald’s birthday party, you will be providing us with personal information, such as your name, address, telephone number, email address. This information is collected to facilitate the booking and arrangement of your McDonald’s birthday party. We may share your information with McDonald’s franchisees, affiliates, subsidiaries of McDonald’s (the McDonald’s Group) or other third parties that assist us in conducting our business for these purposes or other related purposes you would reasonably expect. This may require transferring your information outside of Australia to any McDonald’s Group company or third-party services providers that help McDonald’s provide services. If you do not provide the necessary personal information, we may not be able to arrange a McDonald’s birthday party for you. Our Privacy Policy contains information about how you can access and correct your personal information, how you can lodge a complaint regarding the handling of your personal information and how any privacy complaint will be handled by McDonald’s. You may contact McDonald’s with any queries via email: <a href="mailto:privacy@au.mcd.com" target="_blank"  rel="noopener noreferrer">privacy@au.mcd.com</a> or at McDonald's Australia Limited (Attention: McDonald's Privacy Officer), PO Box 392 Pennant Hills NSW 2120 Australia.</p>
            <p>We recommend that birthday parties be booked for and attended by children aged 3 years and above. We recommend 1 adult per 5 children attending.</p>
            <p>For full party bookings terms and conditions <a href="https://www.mcdonalds.com.au/parties-terms-and-conditions" target="_blank" rel="noopener noreferrer">click here</a> and view our privacy policy <a href="https://www.mcdonalds.com.au/privacy-policy" target="_blank" rel="noopener noreferrer">here</a>.</p>
            <p>*Price per child based on the standard party menu and additional charges may apply depending on choice of restaurant or any additions/variations made to the party package. Extra Charges apply for 6pc Chicken McNuggets® Happy Meal. Final amount will be confirmed at the end of the party. For allergen information, please visit the nutrition section of our website.</p>
            <p className="disclaimer-cakes">^Customers who bring their own birthday cake do so at their own risk. McDonald's accept no liability for any loss, injury, illness or damage, however caused which may be directly or indirectly suffered in connection with food products brought to a birthday party which are not supplied by McDonald's.</p>
            <p>McDonald’s is committed to fostering safe, respectful, and inclusive restaurants to protect the physical and psychological safety of all team members and customers, including children. We take reasonable and appropriate steps for our restaurants to be a place where children are able to have fun whilst feeling safe and respected. All McDonald’s restaurant teams are trained in the role they play in creating a safe, respectful and inclusive workplace. Processes are in place to ensure all restaurant team members have valid clearances to work with children or young people (as required).</p>
            <p>Our differences make us who we are, and we recognise the importance of celebrating different cultures, backgrounds, perspectives, and experiences, including Aboriginal and Torres Strait Islanders children and adults. We are guided by our Values of inclusion, integrity and family and among our actions and commitments are our partnerships with JobSupport and the Australian Disability Network and, more recently, McDonald’s Australia’s Reconciliation Action Plan.</p>
            <p>Across our McDonald’s System, we regularly engage with Aboriginal and Torres Strait Islanders, as employees in our corporate offices and restaurants, as members of the communities we serve, and through sponsorship of grassroots causes and groups. Our vision is for McDonald’s offices and restaurants to continue to be spaces where Aboriginal and Torres Strait Islander people, especially children, are welcomed, acknowledged, respected, celebrated, and feel safe.</p>
            <p>If you have any feedback or concerns about the safety and wellbeing of a child at our restaurant, please contact Customer Service at <strong>02 9875 6666</strong>. We will appropriately address feedback or concerns raised.</p>
          </div>
        </div>
        <div className="Mcd_BPB__disclaimer-box_intro">
          <div className="Mcd_BPB__disclaimer-box_intro__wrapper">
            <p>We recommend that birthday parties be booked for and attended by children aged 3 years and above.</p>
            <p>For full party bookings terms and conditions <a href="https://www.mcdonalds.com.au/parties-terms-and-conditions" target="_blank" rel="noopener noreferrer">click here</a> and view our privacy policy <a href="https://www.mcdonalds.com.au/privacy-policy" target="_blank" rel="noopener noreferrer">here</a>.</p>
            <p>McDonald’s is committed to fostering safe, respectful, and inclusive restaurants to protect the physical and psychological safety of all team members and customers, including children. We take reasonable and appropriate steps for our restaurants to be a place where children are able to have fun whilst feeling safe and respected. All McDonald’s restaurant teams are trained in the role they play in creating a safe, respectful and inclusive workplace. Processes are in place to ensure all restaurant team members have valid clearances to work with children or young people (as required).</p>
            <p>Our differences make us who we are, and we recognise the importance of celebrating different cultures, backgrounds, perspectives, and experiences, including Aboriginal and Torres Strait Islanders children and adults. We are guided by our Values of inclusion, integrity and family and among our actions and commitments are our partnerships with JobSupport and the Australian Disability Network and, more recently, McDonald’s Australia’s Reconciliation Action Plan.</p>
            <p>Across our McDonald’s System, we regularly engage with Aboriginal and Torres Strait Islanders, as employees in our corporate offices and restaurants, as members of the communities we serve, and through sponsorship of grassroots causes and groups. Our vision is for McDonald’s offices and restaurants to continue to be spaces where Aboriginal and Torres Strait Islander people, especially children, are welcomed, acknowledged, respected, celebrated, and feel safe.</p>
            <p>If you have any feedback or concerns about the safety and wellbeing of a child at our restaurant, please contact Customer Service at <strong>02 9875 6666</strong>. We will appropriately address feedback or concerns raised.</p>
          </div>
        </div>

      </div>
    );
  }

}



export default App;
